import { render, staticRenderFns } from "./vmSelectDadataMobileWrap.vue?vue&type=template&id=6b82b34e&scoped=true"
import script from "./vmSelectDadataMobileWrap.vue?vue&type=script&lang=js"
export * from "./vmSelectDadataMobileWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82b34e",
  null
  
)

export default component.exports